import React from 'react';

const SalesTracking = () => (
  <section className="py-2 px-4 bg-gray-100">
    <h4 className='text-1xl font-semibold m-1'>Sales Tracking</h4>
    <div className="max-w-6xl mx-auto shadow-lg border border-gray-200 rounded-lg overflow-hidden">
      <iframe
        title="Purchase Dashboard"
        width="100%"
        height="600"
        src="https://app.powerbi.com/view?r=eyJrIjoiY2RiZmQwYzctMmQ1ZS00MDhjLWI5YTAtMmU4NDc5ZWRlNzYyIiwidCI6IjhjMDYwZTQzLTM1MTEtNGIwZC1iZGI1LTg4NTA2ZmExYmI2MyJ9"
        allowFullScreen
        className="w-full"
      ></iframe>
    </div>
  </section>
);

export default SalesTracking;
